import { createCommand, type LexicalCommand } from 'lexical';

export const OPEN_LINK_DIALOG_COMMAND: LexicalCommand<void> =
  createCommand('OPEN_LINK_DIALOG_COMMAND');
